export default "__VITE_ASSET__DkeQaZp0__"